import React from "react";
import "./Tutorial.scss";
import tutorial1 from "../../assets/demoVideo.mp4";

function Tutorial() {
  return (
    <>
      <div className="tutorial-page">
        <h2 className="tutorial-heading-services">Discover How It Works</h2>
        <div className="video-container">
          <video className="tutorial-video" controls width="600">
            <source src={tutorial1} type="video/mp4" />
          </video>
        </div>
      </div>
    </>
  );
}

export default Tutorial;
